import get from 'lodash/get';

import { type Dictionary, interpolatedString } from '@emobg/web-utils';

/**
 * Allows adding parameters to the translation string.
 * @example <caption>Example usage of compiledTranslation</caption>
 * given translation like this:
 * "welcomePage": {
    "title": "Thanks for choosing {brand}!",
    ...
 * and params object like this: {brand: 'Europcar'}
 * translate('welcomePage.title',{brand})
 * @returns {String} "Thanks for choosing Europcar.".
 */

export const compiledTranslation = (translations: Dictionary<string>, translationKey: string, params?: Dictionary<string>): string => {
  const textFromKey = get(translations, translationKey);
  return interpolatedString(textFromKey, params);
};
